import { AdminSso } from "@/features/admin/sso/sso-admin";

export default function AdminSsoPage() {
  return <AdminSso />;
}
